import(/* webpackMode: "eager" */ "/home/chris/yasi-server/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ClientLogger"] */ "/home/chris/yasi-server/src/components/ClientLogger.tsx");
